import { Flex } from 'antd'
import { RotatedTitle } from '../../../../components/rotated-title/rotated-title'
import WithoutCutting from '../../components/calculation-form/components/form-items/without-cutting'
import { renderCalcPos, onAnyStandardCell } from '../../helpers/helpers'
import type { CalculationColumn } from '../../types/column-types'

export const withoutCuttingColumn: CalculationColumn = {
    dataIndex: 'withoutCutting',
    title: <RotatedTitle style={{ whiteSpace: 'nowrap' }}>Без выс</RotatedTitle>,
    width: 32,
    render: renderCalcPos(r => {
        return (
            <Flex justify={'center'}>
                <WithoutCutting record={r} checked={r.withoutCutting} />
            </Flex>
        )
    }),
    onCell: onAnyStandardCell,
}